


























import Vue from 'vue';
import { BACKEND_URL } from '../constants';
import { Newsitem } from '../itemtypes';

const LATEST_NEWS_URL = BACKEND_URL + '/list/newsitem/?limit=1';

export default Vue.extend({
    
    data() {
        return {
            newsitems: [] as Newsitem[],
        };
    },

    mounted() {
        this.loadData();
    },

    methods: {
        switchDesign() {
            this.$store.dispatch('nextDesign');
        },

        loadData() {
            Vue.axios.get(LATEST_NEWS_URL).then((response: { data: any }) => {
                this.newsitems = response.data.items;
            });
        },

        snippet(item: Newsitem) {
            const div = document.createElement("div");
            div.innerHTML = item.text;
            const text = div.textContent || div.innerText || "";
            return text.substr(0, 100) + "...";
        },
    },
});
